import { Controller } from "@hotwired/stimulus";
const KEY = "kilinka:sidebar:collapsed";

export default class extends Controller {
    connect() {
        const collapsed = localStorage.getItem(KEY) === "1";
        this._apply(collapsed);
    }
    toggle() {
        const collapsed = !this.element.classList.contains("is-collapsed");
        this._apply(collapsed);
        localStorage.setItem(KEY, collapsed ? "1" : "0");
    }
    expand() { if (this.element.classList.contains("is-collapsed")) this.toggle(); }
    _apply(collapsed) {
        this.element.classList.toggle("is-collapsed", collapsed);
        document.querySelector(".kilinka-shell")?.classList.toggle("sidebar-collapsed", collapsed);
    }
}